import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/mail_check.svg';

const MailCheck = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};

export default MailCheck;
